import { defineRecipe } from "@chakra-ui/react";

export const drawerRecipe = defineRecipe({
    variants: {
        variant: {
            large: {
                dialog: {
                    // maxW: `${window.innerWidth * 0.8}px`, // need to verify this not working creates issues with window
                },
            },
        },
    },
});
